import React from "react"
import { graphql, useStaticQuery } from "gatsby"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"

const useCollectionPages = () => {
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()

  const data = useStaticQuery(graphql`query AllCollectionPagesQuery {
  Pages: allCollectionPages(sort: {date: DESC}) {
    nodes {
      id
      locale
      title
      url
      teaserExcerpt
      teaserImage {
        alt
        localImage {
          childImageSharp {
            gatsbyImageData(width: 400, height: 300)
          }
        }
      }
    }
  }
}`)

  /**
   * Get all Pages in the current locale
   */
  return React.useMemo(
    () => data.Pages.nodes.filter(n => n.locale === locale),
    [data, locale]
  )
}

export default useCollectionPages
